'use client';

import { ErrorCode } from '@/utils/errors';

interface ErrorFallbackProps {
  errorCode: ErrorCode;
  errorMessage: string;
  onRetry: () => void;
}

export default function ErrorFallback({ errorCode, errorMessage, onRetry }: ErrorFallbackProps) {
  return (
    <div className='w-full max-w-md bg-white rounded-lg p-6'>
      <div className='flex flex-col items-center mb-6'>
        {errorCode === 'NETWORK_ERROR' ? (
          <svg
            className='w-12 h-12 text-primary mb-2'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z'
            />
          </svg>
        ) : (
          <svg
            className='w-12 h-12 text-primary mb-2'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
            />
          </svg>
        )}
      </div>

      <h2 className='text-lg font-bold text-gray-800 text-center mb-2'>문제가 발생했습니다</h2>
      <p className='text-sm text-gray-600 text-center mb-6'>{errorMessage}</p>

      <div className='space-y-4'>
        {errorCode !== 'SURVEY_DELETED' && (
          <button className='w-full py-3 bg-primary text-white text-sm font-medium rounded-md' onClick={onRetry}>
            다시 시도
          </button>
        )}
        <button
          className='w-full py-3 bg-gray-100 text-gray-700 text-sm font-medium rounded-md'
          onClick={() => (window.location.href = '/')}
        >
          메인으로 이동
        </button>
      </div>

      {process.env.NODE_ENV === 'development' && (
        <details className='mt-6 text-left border-t border-gray-100 pt-3'>
          <summary className='text-xs text-gray-400 cursor-pointer'>개발자용 정보</summary>
          <div className='mt-2 p-2 bg-gray-50 rounded-md text-xs'>
            <p className='text-gray-500'>에러 코드: {errorCode}</p>
            <p className='text-gray-500 mt-1 break-words'>{errorMessage}</p>
          </div>
        </details>
      )}
    </div>
  );
}
